<nav class="navbar bg-light w-100 position-fixed top-0 start-0 py-1">
  <div class="container-fluid d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <button class="btn btn-outline-light me-3 p-0" (click)="toggle()"><span class="navbar-toggler-icon"></span></button>
      <a href="" class="navbar-brand me-3"><img ngSrc="/images/logo-ux-200px.png" alt="Logo" class="img-fluid" width="200" height="52" priority></a>
    </div>

    <div class="d-flex align-items-center">
      <a routerLink="" class="me-3">
        <img ngSrc="/images/icons/home.webp" class="img-fluid" width="18" height="18" alt="Home"/>
      </a>
      <a href="https://jira.logdirect.net/" target="_blank" class="me-3">
        <img ngSrc="/images/icons/jira.webp" class="img-fluid" width="18" height="18" alt="Jira"/>
      </a>
      <a href="https://confluence.logdirect.net/" target="_blank" class="me-3">
        <img ngSrc="/images/icons/confluence.webp" class="img-fluid" width="18" height="18" alt="Confluence"/>
      </a>
      <a href="https://outlook.office.com/mail/" target="_blank" class="me-3">
        <img ngSrc="/images/icons/outlook.webp" class="img-fluid" width="18" height="18" alt="Outlook"/>
      </a>
      <a href="https://app.powerbi.com/browse/shared" target="_blank" class="me-3">
        <img ngSrc="/images/icons/powerbi.webp" class="img-fluid" width="18" height="18" alt="Powerbi"/>
      </a>

      <div class="dropdown">
        <a href="#"
          class="p-0 dropdown-toggle"
          id="userDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false">
          @if (connectedUser?.image) {
            <img [ngSrc]="imageService.getImageUrl($safeNavigationMigration(connectedUser?.image), 32, 32)"
              alt="User Avatar"
              class="rounded-circle avatar img-fluid" width="32" height="32">
          }
        </a>

        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
          @if (connectedUser) {
            <li><a class="dropdown-item" [routerLink]="['/users/users/current']"><i class="bi bi-person-badge-fill me-3"></i>My account</a></li>
          }
          <li><a class="dropdown-item" (click)="logout()" role="button"><i class="bi bi-arrow-bar-right me-3"></i>Logout</a></li>
        </ul>
      </div>
    </div>
  </div>
</nav>
